import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-format"
export default class extends Controller {
  formatServerID(event) {
    const input = event.target
    let value = input.value.replace(/\D/g, '') // Remove all non-digit characters
    
    // Discord server IDs are typically 17-19 digits long
    if (value.length > 19) {
      value = value.slice(0, 19)
    }
    
    input.value = value
  }
}